import { render, staticRenderFns } from "./forget-password.vue?vue&type=template&id=35135417&scoped=true&"
import script from "./forget-password.vue?vue&type=script&lang=ts&"
export * from "./forget-password.vue?vue&type=script&lang=ts&"
import style0 from "./forget-password.vue?vue&type=style&index=0&id=35135417&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35135417",
  null
  
)

export default component.exports